import { $Keys } from 'utility-types';

export enum PositiveDirection {
  up = 'up',
  down = 'down',
  custom = 'custom',
}

export type PositiveDirections = $Keys<typeof PositiveDirection>;
